module.exports = new __parcel__URL__("virtual-agent-settings-app-skeleton.tpl.1a9c03fe.svg").toString();